import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Card,
  List,
  ListItem,
  Divider,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Chip,
  Container,
  IconButton,
  Snackbar,
  Alert,
  Tooltip,
  Skeleton
} from '@mui/material';

import {
  Clear,
  OpenInNew as OpenInNewIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Today as TodayIcon,
  Add as AddIcon
} from '@mui/icons-material';

import VaccinesIcon from '@mui/icons-material/Vaccines';
import PestControlIcon from '@mui/icons-material/PestControl';
import OpacityIcon from '@mui/icons-material/Opacity';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import ShowerIcon from '@mui/icons-material/Shower';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import Sidebar from './Sidebar'; // Asegúrate de importar el componente
import BuscarPacienteAgendarConsulta from './BuscarPacienteAgendarConsulta';
import { useUserData } from '../hooks/useUserData';


import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import api from '../api/api';

const drawerWidth = 0;

// Configuración de Dayjs para manejo de zonas horarias
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');

// *** LÓGICA DE CATEGORÍAS ***
export const categoryLabels = {
  VAC: { title: 'Vacunas', icon: <VaccinesIcon sx={{ fontSize: 24, color: '#1976d2' }} /> },
  DES: { title: 'Desparasitantes', icon: <PestControlIcon sx={{ fontSize: 24, color: '#f57c00' }} /> },
  PIP: { title: 'Pipetas', icon: <OpacityIcon sx={{ fontSize: 24, color: '#7b1fa2' }} /> },
  CIR: { title: 'Cirugías', icon: <HealthAndSafetyIcon sx={{ fontSize: 24, color: '#d32f2f' }} /> },
  BAN: { title: 'Baños', icon: <ShowerIcon sx={{ fontSize: 24, color: '#0288d1' }} /> },
  TER: { title: 'Terapias', icon: <MedicalServicesIcon sx={{ fontSize: 24, color: '#388e3c' }} /> },
};

const getEventColor = (estado) => {
  switch (estado) {
    case 'PRG': return '#1976d2'; // Azul
    case 'APL': return '#388e3c'; // Verde
    case 'CAN': return '#d32f2f'; // Rojo
    case 'PEN': return '#f57c00'; // Naranja
    default: return '#757575';    // Gris
  }
};

const VistaDiariaCitas = ({ openSidebar, setOpenSidebar, fechaSeleccionada }) => {
  const userData = useUserData();
  const [citas, setCitas] = useState([]);
  const [citasFiltradas, setCitasFiltradas] = useState([]);
  const [loading, setLoading] = useState(false);

  // Filtros
  const [filtroSucursal, setFiltroSucursal] = useState(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.id_sucursal && payload.id_sucursal > 0 ? payload.id_sucursal : '';
      } catch (e) { return ''; }
    }
    return '';
  });

  const [filtroEstado, setFiltroEstado] = useState('');
  
  const [filtroNombre, setFiltroNombre] = useState('');
  const [sucursales, setSucursales] = useState([]);
  const [filtroCategoria, setFiltroCategoria] = useState(null);

  // Modal Detalles
  const [selectedCita, setSelectedCita] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newEstadoCita, setNewEstadoCita] = useState('');

  // Modal Agendar Consulta (buscar paciente existente y programar su cita)
  const [modalAgendarOpen, setModalAgendarOpen] = useState(false);

  //const fecha = dayjs(fechaSeleccionada);

  //toke usuario
  //const [userRol, setUserRol] = useState(null);
  //const [sucursalSeleccionada, setSucursalSeleccionada] = useState('');

  const estadosCita = [
    { value: 'PRG', label: 'Programada' },
    { value: 'APL', label: 'Aplicada' },
    { value: 'CAN', label: 'Cancelada' },
    { value: 'PEN', label: 'Pendiente' },
  ];

  // Mapa rápido value -> label para mostrar el chip de estado de forma legible
  const estadoLabelMap = estadosCita.reduce((acc, e) => ({ ...acc, [e.value]: e.label }), {});

  // Feedback no bloqueante (reemplaza los alert())
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//pendientye de este
  //const [fechaVista, setFechaVista] = useState(dayjs());
  const [newFechaCita, setNewFechaCita] = useState(null);
  const [fechaActual, setFechaActual] = useState(dayjs(fechaSeleccionada));

  // Función para formatear fecha idéntica a CitasCalendario.js
  const formatFechaParaBackend = (fechaDayjs) => {
    // 1. Extraer componentes (Naive Date)
    const dateString = fechaDayjs.format('YYYY-MM-DDTHH:mm:ss');
    // 2. Forzar interpretación en zona local (El Salvador)
    const fechaInterpretada = dayjs.tz(dateString, 'YYYY-MM-DDTHH:mm:ss', 'America/El_Salvador');
    // 3. Convertir a ISO UTC
    return fechaInterpretada.toISOString();
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        //setUserRol(payload.id_rol || null);
      } catch (err) {
        console.error('Error decodificando token:', err);
      }
    }
  }, []);

  // Cargar datos
  // Extraído con useCallback para poder llamarlo también al cerrar el modal
  // de "Agendar Consulta" y así refrescar la lista sin necesitar F5.
  const cargarDatos = useCallback(async () => {
    // Si el usuario aún no tiene sucursal definida (ej. cargando token), 
    // podrías decidir esperar o cargar global. Aquí cargamos con lo que haya.
    setLoading(true);
    try {
      const fInicio = fechaActual.format('YYYY-MM-DD 00:00:00');
      const fFin = fechaActual.format('YYYY-MM-DD 23:59:59');

      const params = { fecha_inicio: fInicio, fecha_fin: fFin };

      if (filtroSucursal) {
        params.id_sucursal = filtroSucursal;
      }

      const [resSuc, resCitas] = await Promise.all([
        api.get('/sucursales/'),
        api.get('/citas/all', { params })
      ]);

      setSucursales(resSuc.data || []);

      const sorted = (Array.isArray(resCitas.data) ? resCitas.data : [])
        .sort((a, b) => dayjs(a.fecha_cita).valueOf() - dayjs(b.fecha_cita).valueOf());
      setCitas(sorted);
    } catch (err) {
      console.error("Error al cargar datos:", err);
      setCitas([]);
    } finally {
      setLoading(false);
    }
  }, [fechaActual, filtroSucursal]);

  // Agregamos filtroSucursal a las dependencias para que se recargue al cambiar de sede
  useEffect(() => {
    cargarDatos();
  }, [cargarDatos]);

  // Se cierra el modal de "Agendar Consulta" y refrescamos la lista del día,
  // por si se acaba de programar una nueva consulta.
  const handleCerrarModalAgendar = () => {
    setModalAgendarOpen(false);
    cargarDatos();
  };




// Aplicar filtros
  useEffect(() => {
  let resultado = [...citas];

  if (filtroEstado) resultado = resultado.filter(c => c.estado_cita === filtroEstado);
  if (filtroSucursal) resultado = resultado.filter(c => c.id_sucursal === Number(filtroSucursal));
  
  // *** NUEVO: Filtro por categoría de contador ***
  if (filtroCategoria) {
    resultado = resultado.filter(c => c.tab_categoria === filtroCategoria);
  }

  if (filtroNombre.trim()) {
    const term = filtroNombre.toLowerCase();
    resultado = resultado.filter(c =>
      c.nombre_paciente?.toLowerCase().includes(term) ||
      c.nombre_cliente?.toLowerCase().includes(term)
    );
  }

  setCitasFiltradas(resultado);
}, [citas, filtroEstado, filtroSucursal, filtroNombre, filtroCategoria]); 

  // Conteos por categoría en base al día + filtros de estado/nombre activos
  // (la sucursal ya se aplica en el fetch, y la categoría se excluye para no auto-filtrarse a 0)
  const conteosVisibles = React.useMemo(() => {
    let base = [...citas];
    if (filtroEstado) base = base.filter(c => c.estado_cita === filtroEstado);
    if (filtroNombre.trim()) {
      const term = filtroNombre.toLowerCase();
      base = base.filter(c =>
        c.nombre_paciente?.toLowerCase().includes(term) ||
        c.nombre_cliente?.toLowerCase().includes(term)
      );
    }
    const resultado = { VAC: 0, DES: 0, PIP: 0, CIR: 0, BAN: 0, TER: 0 };
    base.forEach(c => {
      if (resultado[c.tab_categoria] !== undefined) resultado[c.tab_categoria] += 1;
    });
    return resultado;
  }, [citas, filtroEstado, filtroNombre]);

  const limpiarFiltros = () => {
    setFiltroEstado(''); 
    setFiltroNombre(''); 
    setFiltroCategoria(null);
    
    // Opcional: En lugar de '' (Todas), regresamos a la sucursal del token
    const token = localStorage.getItem('token');
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      setFiltroSucursal(payload.id_sucursal || '');
    }
  };

const handleCitaClick = (cita) => {
  setSelectedCita(cita);
  setNewEstadoCita(cita.estado_cita || '');
  // Forzamos la zona horaria antes de formatear para el input datetime-local
  const fechaLocal = dayjs.tz(cita.fecha_cita, 'America/El_Salvador').format('YYYY-MM-DDTHH:mm');
  setNewFechaCita(fechaLocal); 
  setDialogOpen(true);
};

  const handleUpdateEstado = async () => {
  if (!selectedCita || !newEstadoCita || !newFechaCita) return;

  try {
    const fechaFinalBackend = formatFechaParaBackend(dayjs(newFechaCita));

    const res = await api.put(`/citas/${selectedCita.id_cita}`, { 
      estado_cita: newEstadoCita,
      fecha_cita: fechaFinalBackend 
    });
    
    // Actualización local completa para evitar el F5
    setCitas(prev => prev.map(c => 
      c.id_cita === selectedCita.id_cita 
        ? { ...c, estado_cita: newEstadoCita, fecha_cita: res.data.fecha_cita } 
        : c
    ));
    
    setDialogOpen(false);
    setSnackbar({ open: true, message: 'Cita actualizada correctamente', severity: 'success' });
  } catch (err) {
    console.error(err);
    setSnackbar({ open: true, message: 'Error al actualizar la cita', severity: 'error' });
  }
};

  // Navegación rápida entre días
  const irDiaAnterior = () => setFechaActual(prev => prev.subtract(1, 'day'));
  const irDiaSiguiente = () => setFechaActual(prev => prev.add(1, 'day'));
  const irHoy = () => setFechaActual(dayjs());

 return (
    <Box sx={{ display: 'flex', bgcolor: '#f1f5f9', minHeight: '100vh' }}>
      {/* El Sidebar debe recibir las props para que el botón del AppBar funcione[cite: 5, 7] */}
      <Sidebar 
        openSidebar={openSidebar} 
        setOpenSidebar={setOpenSidebar} 
        userRole={userData?.id_rol} 
      /> 
      
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          // Cálculo de ancho: Si el sidebar está abierto, restamos su ancho[cite: 5]
          width: {
            md: openSidebar ? `calc(100% - ${drawerWidth}px)` : '100%',
          },
          // El margen izquierdo debe ser igual al ancho del drawer cuando está abierto[cite: 5]
          ml: {
            md: openSidebar ? `${drawerWidth}px` : -30,
          },
          transition: theme => theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        {/* pt: 10 es vital para que el contenido no quede debajo del GlobalAppBar de App.js */}
        <Container maxWidth="xl" sx={{ pt: 10 }}>
          
          <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
            <Box>
                <Typography variant="h4" fontWeight={800} sx={{ color: '#1e293b' }}>
                  Vista Diaria
                </Typography>
                <Typography variant="subtitle1" sx={{ color: '#64748b' }}>
                  {fechaActual.format('dddd D [de] MMMM YYYY')} — {citasFiltradas.length} citas
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => setModalAgendarOpen(true)}
                sx={{ borderRadius: '8px', textTransform: 'none', fontWeight: 700, boxShadow: 'none' }}
              >
                Agendar Consulta
              </Button>

              <Tooltip title="Día anterior">
                <IconButton onClick={irDiaAnterior} sx={{ bgcolor: 'white', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
                  <ChevronLeftIcon />
                </IconButton>
              </Tooltip>

              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <DatePicker
                  label="Ver otra fecha"
                  value={fechaActual}
                  onChange={(nuevaFecha) => nuevaFecha && setFechaActual(nuevaFecha)}
                  slotProps={{ textField: { size: 'small', sx: { bgcolor: 'white', borderRadius: '8px' } } }}
                />
              </LocalizationProvider>

              <Tooltip title="Día siguiente">
                <IconButton onClick={irDiaSiguiente} sx={{ bgcolor: 'white', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
                  <ChevronRightIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Ir a hoy">
                <IconButton onClick={irHoy} sx={{ bgcolor: 'white', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
                  <TodayIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          <Box sx={{ mb: 3, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {Object.entries(categoryLabels).map(([key, label]) => {
              const isSelected = filtroCategoria === key;
              
              return (
                <Chip
                  key={key}
                  icon={label.icon}
                  label={`${label.title}: ${conteosVisibles[key] || 0}`}
                  onClick={() => setFiltroCategoria(isSelected ? null : key)} // Si haces clic de nuevo, se quita el filtro
                  variant={isSelected ? "filled" : "outlined"}
                  color={isSelected ? "primary" : "default"}
                  sx={{ 
                    fontWeight: 'bold', 
                    bgcolor: isSelected ? '#1e293b' : 'white',
                    color: isSelected ? 'white' : 'inherit',
                    '&:hover': { bgcolor: isSelected ? '#334155' : '#f1f5f9' },
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                />
              );
            })}
            
            {/* Botón opcional para ver todos si hay un filtro activo */}
            {filtroCategoria && (
              <Button size="small" onClick={() => setFiltroCategoria(null)} sx={{ textTransform: 'none' }}>
                Ver todas las categorías
              </Button>
            )}
          </Box>

          {/* Filtros */}
          <Card sx={{ mb: 3, p: 2, borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4}>
                <TextField fullWidth size="small" label="Buscar paciente o cliente" value={filtroNombre} onChange={(e) => setFiltroNombre(e.target.value)} />
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Estado</InputLabel>
                  <Select value={filtroEstado} label="Estado" onChange={(e) => setFiltroEstado(e.target.value)}>
                    <MenuItem value="">Todos</MenuItem>
                    {estadosCita.map(e => <MenuItem key={e.value} value={e.value}>{e.label}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Sucursal</InputLabel>
                  <Select 
                    value={filtroSucursal} // Vinculado al estado que seteamos en el useEffect
                    label="Sucursal" 
                    onChange={(e) => setFiltroSucursal(e.target.value)}
                  >
                    <MenuItem value="">Todas</MenuItem>
                    {sucursales.map(s => (
                      <MenuItem key={s.id_sucursal} value={s.id_sucursal}>
                        {s.nombre_sucursal}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button fullWidth variant="outlined" startIcon={<Clear />} onClick={limpiarFiltros} sx={{ borderRadius: '8px' }}>
                  Limpiar
                </Button>
              </Grid>
            </Grid>
          </Card>

          {/* Lista de Citas */}
          <Card sx={{ borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
            {loading ? (
              <Box sx={{ p: 3 }}>
                {[...Array(4)].map((_, i) => (
                  <Box key={i} sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: i < 3 ? 3 : 0 }}>
                    <Skeleton variant="text" width={70} height={32} />
                    <Skeleton variant="circular" width={24} height={24} />
                    <Box sx={{ flexGrow: 1 }}>
                      <Skeleton variant="text" width="40%" />
                      <Skeleton variant="text" width="25%" />
                    </Box>
                    <Skeleton variant="rounded" width={70} height={24} />
                  </Box>
                ))}
              </Box>
            ) : (
              <List>
                {citasFiltradas.length > 0 ? (
                  citasFiltradas.map((cita, index) => (
                    <React.Fragment key={cita.id_cita}>
                      <ListItem sx={{ py: 2.5, px: { xs: 2, sm: 3 }, '&:hover': { bgcolor: '#f8fafc' }, cursor: 'pointer' }} onClick={() => handleCitaClick(cita)}>
                        <Box sx={{
                          display: 'flex',
                          width: '100%',
                          flexDirection: { xs: 'column', sm: 'row' },
                          alignItems: { xs: 'flex-start', sm: 'center' },
                          gap: { xs: 1.5, sm: 3 }
                        }}>
                          <Box sx={{ display: 'flex', width: { xs: '100%', sm: 'auto' }, justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="h6" fontWeight={700} color="primary" sx={{ minWidth: { sm: 110 } }}>
                              {dayjs.tz(cita.fecha_cita, 'America/El_Salvador').format('hh:mm A')}
                            </Typography>
                            {/* En móvil el chip de estado va junto a la hora, arriba */}
                            <Chip
                              label={estadoLabelMap[cita.estado_cita] || 'Pendiente'}
                              size="small"
                              sx={{
                                display: { xs: 'inline-flex', sm: 'none' },
                                bgcolor: getEventColor(cita.estado_cita),
                                color: 'white',
                                fontWeight: 'bold',
                                borderRadius: '6px'
                              }}
                            />
                          </Box>
                          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 }}>
                            {cita.tab_categoria && categoryLabels[cita.tab_categoria] && (
                              <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                                {categoryLabels[cita.tab_categoria].icon}
                              </Box>
                            )}
                            <Box sx={{ minWidth: 0 }}>
                              <Typography variant="h6" fontWeight={600} sx={{ color: '#1e293b' }}>
                                {cita.nombre_paciente}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="primary.main"
                                sx={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 0.5, '&:hover': { textDecoration: 'underline' } }}
                                onClick={(e) => { e.stopPropagation(); window.open(`/clientes/${cita.id_cliente}`, '_blank'); }}
                              >
                                {cita.nombre_cliente}
                                <OpenInNewIcon sx={{ fontSize: 16 }} />
                              </Typography>
                              {cita.razon_consulta && (
                                <Typography variant="body2" sx={{ mt: 0.5, color: '#64748b' }}>
                                  {cita.razon_consulta}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                          {/* En escritorio el chip va al final de la fila */}
                          <Chip
                            label={estadoLabelMap[cita.estado_cita] || 'Pendiente'}
                            size="small"
                            sx={{
                              display: { xs: 'none', sm: 'inline-flex' },
                              flexShrink: 0,
                              bgcolor: getEventColor(cita.estado_cita),
                              color: 'white',
                              fontWeight: 'bold',
                              borderRadius: '6px'
                            }}
                          />
                        </Box>
                      </ListItem>
                      {index < citasFiltradas.length - 1 && <Divider />}
                    </React.Fragment>
                  ))
                ) : (
                  <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography color="textSecondary">
                      {citas.length > 0
                        ? 'Ningún resultado coincide con los filtros aplicados.'
                        : 'No hay citas programadas para este día.'}
                    </Typography>
                    {citas.length > 0 && (
                      <Button size="small" onClick={limpiarFiltros} sx={{ mt: 1, textTransform: 'none' }}>
                        Limpiar filtros
                      </Button>
                    )}
                  </Box>
                )}
              </List>
            )}
          </Card>
        </Container>
      </Box>

      {/* ==================== MODAL AGENDAR CONSULTA ==================== */}
      <Dialog
        open={modalAgendarOpen}
        onClose={handleCerrarModalAgendar}
        maxWidth="sm"
        fullWidth
        sx={{ '& .MuiDialog-paper': { borderRadius: '12px', bgcolor: 'transparent', boxShadow: 'none' } }}
      >
        <BuscarPacienteAgendarConsulta
          visible={modalAgendarOpen}
          onClose={handleCerrarModalAgendar}
          initialDate={fechaActual}
        />
      </Dialog>

      {/* ==================== MODAL DETALLES ==================== */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="md" fullWidth sx={{ '& .MuiDialog-paper': { borderRadius: '12px' } }}>
        <DialogTitle sx={{ bgcolor: '#1e293b', color: 'white', py: 2.5 }}>
          Detalles de la Cita
        </DialogTitle>
        <DialogContent dividers sx={{ py: 2 }}>
          {selectedCita && (
            <TableContainer sx={{ '& .MuiTableCell-root': { py: 1.5 } }}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', width: 220, color: '#64748b' }}>Paciente</TableCell>
                    <TableCell sx={{ fontSize: '1.1rem', fontWeight: 700 }}>{selectedCita.nombre_paciente}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', color: '#64748b' }}>Propietario</TableCell>
                    <TableCell>
                      <Typography
                        variant="body1"
                        color="primary.main"
                        sx={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 0.5, '&:hover': { textDecoration: 'underline' } }}
                        onClick={() => window.open(`/clientes/${selectedCita.id_cliente}`, '_blank')}
                      >
                        {selectedCita.nombre_cliente}
                        <OpenInNewIcon sx={{ fontSize: 18 }} />
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ bgcolor: '#f8fafc' }}>
                    <TableCell sx={{ fontWeight: 'bold', color: '#64748b' }}>Fecha y Hora</TableCell>
                    <TableCell>
                      <TextField
                        fullWidth
                        type="datetime-local"
                        value={newFechaCita}
                        onChange={(e) => setNewFechaCita(e.target.value)}
                        size="small"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow><TableCell colSpan={2} sx={{ bgcolor: '#f1f5f9', fontWeight: 800, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#475569' }}>Información de Contacto</TableCell></TableRow>
                  <TableRow><TableCell sx={{ color: '#64748b' }}>Teléfonos</TableCell><TableCell>{selectedCita.telefonos_cliente || '—'}</TableCell></TableRow>
                  <TableRow><TableCell sx={{ color: '#64748b' }}>Email</TableCell><TableCell>{selectedCita.email_cliente || '—'}</TableCell></TableRow>
                  <TableRow><TableCell colSpan={2} sx={{ bgcolor: '#f1f5f9', fontWeight: 800, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#475569' }}>Detalles de la Consulta</TableCell></TableRow>
                  <TableRow><TableCell sx={{ color: '#64748b' }}>Razón de consulta</TableCell><TableCell>{selectedCita.razon_consulta || 'No especificada'}</TableCell></TableRow>
                  <TableRow><TableCell sx={{ color: '#64748b' }}>Descripción</TableCell><TableCell>{selectedCita.descripcion || 'Sin notas'}</TableCell></TableRow>
                  <TableRow><TableCell colSpan={2} sx={{ bgcolor: '#f1f5f9', fontWeight: 800, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#475569' }}>Gestión de Estado</TableCell></TableRow>
                  <TableRow>
                    <TableCell sx={{ color: '#64748b' }}>Estado Actual</TableCell>
                    <TableCell>
                      <Select fullWidth size="small" value={newEstadoCita} onChange={(e) => setNewEstadoCita(e.target.value)}>
                        {estadosCita.map(est => (
                          <MenuItem key={est.value} value={est.value}>{est.label}</MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', color: '#64748b' }}>ID Cita</TableCell>
                      <TableCell>{selectedCita.id_cita}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', color: '#64748b' }}>ID Sucursal</TableCell>
                      <TableCell>{selectedCita.id_sucursal}</TableCell>
                    </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5, bgcolor: '#f8fafc' }}>
          <Button onClick={() => setDialogOpen(false)} sx={{ color: '#64748b' }}>Cerrar</Button>
          <Button 
            variant="contained" 
            onClick={handleUpdateEstado} 
            disabled={ !newEstadoCita || (newEstadoCita === selectedCita?.estado_cita && newFechaCita === dayjs.tz(selectedCita?.fecha_cita, 'America/El_Salvador').format('YYYY-MM-DDTHH:mm')) }
            sx={{ bgcolor: '#4f46e5', '&:hover': { bgcolor: '#4338ca' }, borderRadius: '8px', textTransform: 'none' }}
          >
            Actualizar Cita
          </Button>
        </DialogActions>
      </Dialog>

      {/* ==================== FEEDBACK NO BLOQUEANTE ==================== */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ borderRadius: '8px' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default VistaDiariaCitas;